import { render } from "./ErrorComponent.vue?vue&type=template&id=8e7ed9f4"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import "./ErrorComponent.vue?vue&type=style&index=0&id=8e7ed9f4&lang=css"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__